import Blue from "~/core";

new Blue({
	name: 'Location Finder - Geocoding and API Call',
	selector: ".location-finder",
	setup(container) {
		const input = container.querySelector("input.location-finder__form-input");
		const successDiv = container.querySelector(".location-finder__success");
		const successHeadingLink = successDiv.querySelector(".location-finder__success-heading > a");
		const successPhone = successDiv.querySelector(".location-finder__success-phone");
		const successStreet = successDiv.querySelector("address.location-finder__success-address > span:first-child");
		const successCityStateZip = successDiv.querySelector("address.location-finder__success-address > span:last-child");
		
		if (navigator.geolocation) {
			var mapBoxToken = 'pk.eyJ1IjoiYmx1ZXJoaW5vIiwiYSI6ImNqZDJjYjZxeDFzcHUzM213MGdoOTh4dXUifQ.0St02mA2vqSMM5qsvMfngQ';
			let lat;
			let lng;
			let address = {};
			let nearestLocation;
			const options = {
				enableHighAccuracy: true,
				timeout: 5000,
				maximumAge: 0
			};

			const editSuccessMarkup = () => {
				let locCityState = nearestLocation.address.city + ", " + nearestLocation.address.state;
				successHeadingLink.textContent = locCityState;
				successHeadingLink.setAttribute("href", nearestLocation.url);
				successPhone.textContent = nearestLocation.phoneNumber;
				successPhone.setAttribute("href", "tel:" + nearestLocation.phoneNumber);
				successStreet.textContent = nearestLocation.address.street;
				successCityStateZip.textContent = locCityState + " " + nearestLocation.address.zipCode;
				container.classList.add("location-finder--success");
			}

			const  getServiceInfo = async (lat, lng) => {
				let url = container.getAttribute("data-api-endpoint");
				let data = {
					lat,
					lng
				};
				await fetch(url, {
					method: 'POST', 
					headers: {
						'Content-Type': 'application/json',
						'accept': 'application/json'
					},
					body: JSON.stringify(data)
				})
				.then(response => response.json())
				.then(data => {
					if (data.locations && data.locations.length > 0 && !!data.locations[0].address.city) {
						nearestLocation = data.locations[0];
						editSuccessMarkup();
					}
				})
				.catch((error) => {
					console.error('Error:', error);
				});
			}
			
			const getAddress = async (lat, lng) => {
				let url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?access_token=${mapBoxToken}`;
				await fetch(url)
					.then(response => response.json())
					.then(data => {
						let zip = data.features.find(f => f.id.startsWith("postcode")).text 
							|| data.features.find(f => f.place_type[0] === "postcode").place_type[0] 
							|| "";
						input.value = zip;
						getServiceInfo(lat, lng, address);
					});
			}

			const success = async (pos) => {
				lat = pos.coords.latitude;
				lng = pos.coords.longitude;
				await getAddress(lat, lng);
			}
			const error = (err) => {
				console.warn(`ERROR(${err.code}): ${err.message}`);
			}
			navigator.geolocation.getCurrentPosition(success, error, options);	
		}
	}
});

new Blue({
	name: 'Location Finder - Submit Error Handling',
	selector: ".location-finder__form",
	setup(container) {
		const input = container.querySelector("input.location-finder__form-input");
		const submit = container.querySelector(".location-finder__form-submit");

		this.$addEvents(submit, "click", e => {
			if (input.value === "") {
				e.preventDefault();
				input.classList.add("empty");
			}
		});
		this.$addEvents(input, "input", () => {
			if (!!input.value) {
				input.classList.remove("empty");
			}
		});
	}
});